import React, { useState, useEffect } from 'react';
import { Space, Button, DatePicker } from 'antd';
import { EditOutlined, SaveOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

/**
 * Inline editable date — same UX as facture TitleRefEditor date.
 * Displays DD/MM/YYYY; on save emits YYYY-MM-DD (or ISO if withTime).
 */
const EditableDateField = ({
  value,
  onChange,
  disabled = false,
  format = 'DD/MM/YYYY',
  withTime = false,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedDate, setEditedDate] = useState(value ? dayjs(value) : null);

  useEffect(() => {
    if (!isEditing) {
      setEditedDate(value ? dayjs(value) : null);
    }
  }, [value, isEditing]);

  const display = value
    ? dayjs(value).format(withTime ? 'DD/MM/YYYY HH:mm' : format)
    : '—';

  const handleSave = () => {
    if (!editedDate) return;
    if (withTime) {
      // Preserve time from original value when only the day changes
      const next = editedDate.toDate();
      if (value) {
        const original = dayjs(value);
        next.setHours(original.hour(), original.minute(), original.second(), original.millisecond());
      }
      onChange(next.toISOString());
    } else {
      onChange(editedDate.format('YYYY-MM-DD'));
    }
    setIsEditing(false);
  };

  const handleCancel = () => {
    setEditedDate(value ? dayjs(value) : null);
    setIsEditing(false);
  };

  if (isEditing) {
    return (
      <Space size={4}>
        <DatePicker
          value={editedDate}
          onChange={setEditedDate}
          format={format}
          autoFocus
          allowClear={false}
        />
        <Button type="link" icon={<SaveOutlined />} onClick={handleSave} size="small" />
        <Button type="link" danger onClick={handleCancel} size="small">
          Cancel
        </Button>
      </Space>
    );
  }

  return (
    <Space size={4}>
      <span>{display}</span>
      {!disabled && (
        <Button
          type="link"
          icon={<EditOutlined />}
          onClick={() => setIsEditing(true)}
          size="small"
        />
      )}
    </Space>
  );
};

export default EditableDateField;
